<!--?===========Template========================================-->
<template>
  <div class="custom-hero">
    <div class="hero-content">
      <div class="col-md-6 p-lg-5 mx-auto my-5" id="hero-content-conetnt">
        <img
          src="../assets/images/Logo.png"
          width="150px"
          height="150px"
          alt="Desarrollo web profesional y creación desitios modernos"
        />
        <h1 class="display-3 fw-bold hero-title animate-title">Leonar2</h1>
        <h3 class="fw-normal hero-subtitle mb-3 animate-subtitle">
          Crea todo aquello que imagines
        </h3>
        <div class="buttons-container animate-buttons">
          <!-- Button trigger modal -->
          <button
            type="button"
            class="icon-link hero-link"
            @click="showModal = true"
          >
            Contactar
          </button>

          <!-- Modal bonito y funcional -->
          <div
            v-if="showModal"
            class="modal-overlay"
            @click="showModal = false"
          >
            <div class="modal-content custom-modal" @click.stop>
              <div class="modal-header">
                <h1 class="modal-title">ATENCIÓN</h1>
              </div>
              <div class="modal-body">
                Este enlace lo sacará de su navegador y lo llevará al WhatsApp
                de Leonardo para contactar. ¿Desea continuar?
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-cancel"
                  @click="showModal = false"
                >
                  CANCELAR
                </button>
                <button
                  type="button"
                  class="btn btn-continue"
                  @click="goToWhatsApp"
                >
                  CONTINUAR
                </button>
              </div>
            </div>
          </div>
          <RouterLink to="/Servicios" class="icon-link hero-link">
            <span class="btn-text">Servicios</span>
          </RouterLink>
        </div>
      </div>
    </div>
    <div class="product-device shadow-sm animate-device-1"></div>
    <div
      class="product-device product-device-2 shadow-sm animate-device-2"
    ></div>
  </div>

  <div id="aboutC1" class="animate-on-scroll">
    <h1 class="m-3 display-4 center" id="AcercaMi">Acerca de mí</h1>
    <div id="imagen">
      <img
        src="../assets/images/Yo.jpg"
        class="img-fluid rounded-circle w-3 h-3"
        id="image"
        width="188"
        height="188"
        alt="Leonardo Rios desarrollador fronted"
      />
    </div>
    <div id="aboutText">
      <h5 id="aboutTex" class="m-3 text-center">
        Mi nombre es Leonardo Rios soy programador y desarrollador web, me dedico
        a la creación y/o actualización de sitios web modernos y funcionales
        para empresas y negocios y a la automatizacion de procesos como
        contabilidad o gestiones de servicios tengo conocimiento de una serie de
        lenguajes y acerca del uso de IAs, freamworks y herramientas para dar un
        servicio de la más alta calidad ...
      </h5>
      <Router-link to="/Yo" class="btn btn-primary btn-lg">Más Acerca de mí</Router-link>
    </div>
  </div>

  <div class="features-section animate-on-scroll px-4 py-5">
    <div class="container">
      <h2 class="pb-2 border-bottom">Servicios de L2:</h2>

      <div class="row row-cols-1 row-cols-md-2 align-items-md-center g-5 py-5">
        <div class="col d-flex flex-column align-items-start gap-2">
          <h2 class="fw-bold text-body-emphasis">¿Qué es L2?</h2>
          <p class="text-body-secondary">
            L2 es mi marca profesional creada para ofrecer a mis clientes una
            serie de servicios para sus negocios haciendo función de estudio
            web, asesor técnico entre otros.
          </p>
          <Router-link to="/Servicios" class="btn btn-primary btn-lg"
            >Ver Servicios</Router-link
          >
        </div>

        <div class="col">
          <div class="row row-cols-1 row-cols-sm-2 g-4">
            <div class="col d-flex flex-column gap-2">
              <div
                class="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  class="bi bi-code-slash"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0m6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0"
                  />
                </svg>
              </div>
              <h4 class="fw-semibold mb-0 text-body-emphasis">
                Desarrollo de Páginas Web para su local
              </h4>
            </div>

            <div class="col d-flex flex-column gap-2">
              <div
                class="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  class="bi bi-window-sidebar"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
                  />
                  <path
                    d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v2H1V3a1 1 0 0 1 1-1zM1 13V6h4v8H2a1 1 0 0 1-1-1m5 1V6h9v7a1 1 0 0 1-1 1z"
                  />
                </svg>
              </div>
              <h4 class="fw-semibold mb-0 text-body-emphasis">
                Optimización y Actualización de Sitios Webs
              </h4>
            </div>

            <div class="col d-flex flex-column gap-2">
              <div
                class="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  class="bi bi-database"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M4.318 2.687C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4c0-.374.356-.875 1.318-1.313M13 5.698V7c0 .374-.356.875-1.318 1.313C10.766 8.729 9.464 9 8 9s-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777A5 5 0 0 0 13 5.698M14 4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16s3.022-.289 4.096-.777C13.125 14.755 14 14.007 14 13zm-1 4.698V10c0 .374-.356.875-1.318 1.313C10.766 11.729 9.464 12 8 12s-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10s3.022-.289 4.096-.777A5 5 0 0 0 13 8.698m0 3V13c0 .374-.356.875-1.318 1.313C10.766 14.729 9.464 15 8 15s-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13s3.022-.289 4.096-.777c.324-.147.633-.323.904-.525"
                  />
                </svg>
              </div>
              <h4 class="fw-semibold mb-0 text-body-emphasis">
                Automatización de Contabilidad y otras tareas
              </h4>
            </div>

            <div class="col d-flex flex-column gap-2">
              <div
                class="feature-icon-small d-inline-flex align-items-center justify-content-center text-bg-primary bg-gradient fs-4 rounded-3"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  class="bi bi-openai"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M14.949 6.547a3.94 3.94 0 0 0-.348-3.273 4.11 4.11 0 0 0-4.4-1.934A4.1 4.1 0 0 0 8.423.2 4.15 4.15 0 0 0 6.305.086a4.1 4.1 0 0 0-1.891.948 4.04 4.04 0 0 0-1.158 1.753 4.1 4.1 0 0 0-1.563.679A4 4 0 0 0 .554 4.72a3.99 3.99 0 0 0 .502 4.731 3.94 3.94 0 0 0 .346 3.274 4.11 4.11 0 0 0 4.402 1.933c.382.425.852.764 1.377.995.526.231 1.095.35 1.67.346 1.78.002 3.358-1.132 3.901-2.804a4.1 4.1 0 0 0 1.563-.68 4 4 0 0 0 1.14-1.253 3.99 3.99 0 0 0-.506-4.716m-6.097 8.406a3.05 3.05 0 0 1-1.945-.694l.096-.054 3.23-1.838a.53.53 0 0 0 .265-.455v-4.49l1.366.778q.02.011.025.035v3.722c-.003 1.653-1.361 2.992-3.037 2.996m-6.53-2.75a2.95 2.95 0 0 1-.36-2.01l.095.057L5.29 12.09a.53.53 0 0 0 .527 0l3.949-2.246v1.555a.05.05 0 0 1-.022.041L6.473 13.3c-1.454.826-3.311.335-4.15-1.098m-.85-6.94A3.02 3.02 0 0 1 3.07 3.949v3.785a.51.51 0 0 0 .262.451l3.93 2.237-1.366.779a.05.05 0 0 1-.048 0L2.585 9.342a2.98 2.98 0 0 1-1.113-4.094zm11.216 2.571L8.747 5.576l1.362-.776a.05.05 0 0 1 .048 0l3.265 1.86a3 3 0 0 1 1.173 1.207 2.96 2.96 0 0 1-.27 3.2 3.05 3.05 0 0 1-1.36.997V8.279a.52.52 0 0 0-.276-.445m1.36-2.015-.097-.057-3.226-1.855a.53.53 0 0 0-.53 0L6.249 6.153V4.598a.04.04 0 0 1 .019-.04L9.533 2.7a3.07 3.07 0 0 1 3.257.139c.474.325.843.778 1.066 1.303.223.526.289 1.103.191 1.664zM5.503 8.575 4.139 7.8a.05.05 0 0 1-.026-.037V4.049c0-.57.166-1.127.476-1.607s.752-.864 1.275-1.105a3.08 3.08 0 0 1 3.234.41l-.096.054-3.23 1.838a.53.53 0 0 0-.265.455zm.742-1.577 1.758-1 1.762 1v2l-1.755 1-1.762-1z"
                  />
                </svg>
              </div>
              <h4 class="fw-semibold mb-0 text-body-emphasis">
                Asesoría e implementación de IAs en negocios
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="promo-banner">
    <div class="container">
      <div class="promo-content">
        <div class="promo-icon">⚡</div>
        <div class="promo-text">
          <h3>¿Quieres una cotización rápida?</h3>
          <p>
            Completa el formulario y recibirás una respuesta prioritaria con
            precios y plazos exactos
          </p>
          <Router-link to="/Contacto" class="btn btn-primary btn-lg"
            >Ir al formulario</Router-link
          >
        </div>
      </div>
    </div>
  </section>
</template>

<!--!===========SCRIPT========================================-->
<script setup>
import { onMounted, ref } from 'vue';

// Modal simple

const showModal = ref(false);

// Función para ir a WhatsApp
const goToWhatsApp = () => {
  window.open('https://wa.me/5352940801', '_blank');
  showModal.value = false;
};
onMounted(() => {
  // === Animaciones del HERO (las originales) ===
  const animateHero = () => {
    const title = document.querySelector('.animate-title');
    const subtitle = document.querySelector('.animate-subtitle');
    const buttons = document.querySelector('.animate-buttons');
    const device1 = document.querySelector('.animate-device-1');
    const device2 = document.querySelector('.animate-device-2');

    setTimeout(() => {
      title?.classList.add('animated');
      subtitle?.classList.add('animated');
      buttons?.classList.add('animated');
      device1?.classList.add('animated');
      device2?.classList.add('animated');
    }, 300);
  };

  animateHero();

  // === Animaciones al hacer scroll (About + Features) ===
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target); // deja de observar una vez animado
        }
      });
    },
    {
      threshold: 0.15, // se activa cuando al menos 15% del elemento es visible
    }
  );

  // Observa todas las secciones con la clase .animate-on-scroll
  const scrollElements = document.querySelectorAll('.animate-on-scroll');
  scrollElements.forEach((el) => observer.observe(el));
});
</script>

<!--TODO===========STYLE========================================-->
<style scoped>
/* =========================
   VARIABLES DE COLOR
========================= */
:root {
  --color-background: #f8f9fa;
  --color-surface: #ffffff;
  --color-text-primary: #212529;
  --color-text-secondary: #6c757d;
  --color-primary: #0d6efd;
  --color-border: #dee2e6;
}

/* =========================
   HERO PRINCIPAL (100% VIEWPORT)
========================= */
.custom-hero {
  background-color: var(--color-background);
  color: var(--color-text-primary);
  position: relative;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  height: 100vh; /* Cambiado de min-height a height */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 0 !important;
  margin-top: 55px !important;
  padding: 0; /* Eliminado padding para ocupar todo el espacio */
}

.hero-content {
  position: relative;
  z-index: 10;
  text-align: center;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
}

#hero-content-conetnt {
  padding: 0 !important;
  margin: 0 auto !important; /* Centrado sin margen superior/inferior */
  max-width: 900px;
}

.hero-title,
.hero-subtitle {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease-out;
}

.animate-title.animated,
.animate-subtitle.animated {
  opacity: 1;
  transform: translateY(0);
}

/* =========================
   BOTONES HERO
========================= */
.hero-link {
  color: var(--color-primary) !important;
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  border: 2px solid var(--color-primary);
  border-radius: 8px;
  transition: all 1.2s ease;
  background-color: transparent;
  font-weight: 600;
  width: 120px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease-out 0.4s;
}
.buttons-container {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.hero-link:hover {
  background-color: var(--color-primary);
  color: var(--color-background) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(92, 141, 246, 0.4);
}

.animate-buttons.animated .hero-link {
  opacity: 1;
  transform: translateY(0);
}

/* =========================
   MODAL BONITO
========================= */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.modal-content {
  background: #1b2330;
  border: none;
  border-radius: 15px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  max-width: 450px;
  width: 90%;
  overflow: hidden;
  animation: modalAppear 0.3s ease-out;
}

.modal-header {
  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
  color: white;
  padding: 1.5rem;
  text-align: center;
}

.modal-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.modal-body {
  padding: 2rem 1.5rem;
  color: #212529;
  font-size: 1.1rem;
  line-height: 1.6;
  text-align: center;
  background: var(--color-border);
}

.modal-footer {
  padding: 1.5rem;
  background: var(--color-border);
  display: flex;
  gap: 1rem;
  justify-content: center;
  border-top: 1px solid #e9ecef;
}

.btn-cancel {
  background: transparent;
  color: #6c757d;
  border: 2px solid #6c757d;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.btn-cancel:hover {
  background: #6c757d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(108, 117, 125, 0.3);
}

.btn-continue {
  background: transparent;
  color: var(--color-primary);
  border: 2px solid #198754;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.btn-continue:hover {
  background: #198754;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(25, 135, 84, 0.3);
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* =========================
   DISPOSITIVOS FLOTANTES
========================= */
.product-device {
  position: absolute;
  right: 10%;
  bottom: -30%;
  width: 300px;
  height: 540px;
  border-radius: 21px;
  transform: rotate(30deg);
  opacity: 0;
  visibility: visible !important;
  z-index: 1;
  border: none;
  transition: all 1.5s ease-out;
}

.product-device::before {
  position: absolute;
  top: 10%;
  right: 10px;
  bottom: 10%;
  left: 10px;
  content: "";
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 100%
  );
  border-radius: 5px;
}

.product-device {
  background: linear-gradient(
    135deg,
    #3c27ffe7 0%,
    #4636dad7 50%,
    #2d5ee6d7 100%
  );
  box-shadow: 0 20px 40px rgba(157, 189, 255, 0.4);
  transform: rotate(30deg) translateX(100px);
}

.product-device-2 {
  top: -25%;
  right: auto;
  left: 5%;
  bottom: 0;
  background: linear-gradient(135deg, #0f96a8 0%, #21c8dfdc 50%, #9dbdff 100%);
  box-shadow: 0 20px 40px rgba(92, 141, 246, 0.4);
  transform: rotate(-15deg) translateX(-100px);
}

.animate-device-1.animated {
  opacity: 1;
  transform: rotate(30deg) translateX(0);
}

.animate-device-2.animated {
  opacity: 1;
  transform: rotate(-15deg) translateX(0);
}

/* =========================
   ACERCA DE MÍ (100% VIEWPORT)
========================= */
#aboutC1 {
  padding: 10%;
  min-height: 100vh; /* Añadido para ocupar toda la pantalla */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease-out;
}

#aboutC1.animated {
  opacity: 1;
  transform: translateY(0);
}

#AcercaMi {
  border-bottom: 3px solid var(--color-text-primary);
  display: inline-block;
  padding-bottom: 0.5rem;
  margin-bottom: 2rem;
  text-align: center;
  width: 100% !important;
}

#imagen {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

#aboutText {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;
  text-align: justify;
}

#aboutText h5:first-of-type {
  flex: 1 1 60%;
  min-width: 250px;
}

#aboutText h5:last-of-type {
  flex: 1 1 100%;
}

/* =========================
   FEATURES SECTION (100% VIEWPORT + ANIMACIÓN)
========================= */
.features-section {
  background-color: var(--color-surface) !important;
  width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  color: var(--color-text-primary);
  min-height: 100vh; /* Añadido para ocupar toda la pantalla */
  display: flex;
  align-items: center;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease-out;
}

.features-section.animated {
  opacity: 1;
  transform: translateY(0);
}

.features-section .container {
  max-width: 1200px;
  margin: 0 auto;
}

.features-section h2.pb-2 {
  border-bottom: 3px solid var(--color-text-primary) !important;
  padding-bottom: 0.8rem !important;
  color: var(--color-text-primary);
}

.features-section .text-body-emphasis {
  color: var(--color-text-primary) !important;
}

.features-section .text-body-secondary {
  color: var(--color-text-secondary) !important;
}

.feature-icon-small {
  width: 3rem;
  height: 3rem;
  border-radius: 8px !important;
}

/* =========================
   RESPONSIVE
========================= */
@media (max-width: 768px) {
  .custom-hero {
    height: 100vh;
    padding: 0;
  }

  .hero-title {
    font-size: 2.5rem;
  }

  .hero-subtitle {
    font-size: 1.2rem;
  }
  .buttons-container {
    flex-direction: column;
    gap: 0.8rem;
    width: 100%;
  }

  .product-device {
    width: 180px;
    height: 320px;
    right: 3%;
    bottom: -15%;
    opacity: 0;
    transform: rotate(30deg) translateX(50px);
  }

  .product-device-2 {
    width: 160px;
    height: 280px;
    left: 2%;
    top: -12%;
    opacity: 0;
    transform: rotate(-15deg) translateX(-50px);
  }

  .animate-device-1.animated {
    opacity: 0.9 !important;
    transform: rotate(30deg) translateX(0);
  }

  .animate-device-2.animated {
    opacity: 0.9 !important;
    transform: rotate(-15deg) translateX(0);
  }

  .d-flex {
    flex-direction: column;
    gap: 1rem !important;
  }

  .hero-link {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
    width: 200px !important;
    height: 40px;
    margin: 0 auto;
  }

  #aboutC1 {
    padding: 5%;
    min-height: 100vh;
  }
}

@media (max-width: 480px) {
  .custom-hero {
    height: 100vh;
  }

  .hero-title {
    font-size: 2rem;
  }
  .buttons-container {
    gap: 0.6rem;
  }
  .product-device {
    width: 140px;
    height: 250px;
    right: 2%;
    bottom: -10%;
    opacity: 0;
    transform: rotate(30deg) translateX(30px);
  }

  .product-device-2 {
    width: 120px;
    height: 220px;
    left: 1%;
    top: -8%;
    opacity: 0;
    transform: rotate(-15deg) translateX(-30px);
  }

  .animate-device-1.animated {
    opacity: 0.85 !important;
    transform: rotate(30deg) translateX(0);
  }

  .animate-device-2.animated {
    opacity: 0.85 !important;
    transform: rotate(-15deg) translateX(0);
  }

  .hero-link {
    width: 180px;
    height: 38px;
    font-size: 0.9rem;
  }
  #aboutText {
    flex-direction: column;
  }
  #aboutText h5:first-of-type {
    flex: 1 1 100%;
  }
  .features-section .row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .features-section .col {
    background: linear-gradient(135deg, #091222 0%, #0c172b 100%);
    border-radius: 12px;
    padding: 1.2rem;
    border: 1px solid #0e1117;
  }
}

@media (max-width: 360px) {
  .hero-title {
    font-size: 1.5rem;
  }

  .hero-subtitle {
    font-size: 0.9rem;
  }

  .d-flex {
    flex-direction: column !important;
    gap: 0.5rem !important;
  }

  .product-device {
    width: 120px;
    height: 200px;
    transform: rotate(30deg) translateX(20px);
  }

  .product-device-2 {
    width: 100px;
    height: 180px;
    transform: rotate(-15deg) translateX(-20px);
  }

  .animate-device-1.animated {
    transform: rotate(30deg) translateX(0);
  }

  .animate-device-2.animated {
    transform: rotate(-15deg) translateX(0);
  }
}
/* CARTEL PROMOCIONAL */
.promo-banner {
  background: linear-gradient(135deg, var(--color-primary) 0%, #0a58ca 100%);
  color: white;
  padding: 3rem 20px;
}

.promo-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  max-width: 800px;
  margin: 0 auto;
  text-align: left;
}

.promo-icon {
  font-size: 3rem;
  flex-shrink: 0;
}

.promo-text h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.5rem;
}

.promo-text p {
  margin: 0;
  opacity: 0.9;
}
</style>
